var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBoatLandingLightL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 138,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 98,
    width: 130,
    height: 138
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-23 -98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.9576 21.8626C78.3932 21.8626 81.2041 24.6736 81.2041 28.1091 81.2041 31.5447 78.3932 34.3556 74.9576 34.3556 71.5221 34.3556 68.7112 31.5447 68.7112 28.1091 68.7112 24.6736 71.5221 21.8626 74.9576 21.8626ZM127.272 72.7714C127.116 71.6782 126.335 70.7413 125.398 70.2728 124.461 69.8043 123.212 69.9605 122.275 70.7413L104.628 84.3273C103.691 84.952 103.223 86.0451 103.379 87.2944 103.535 88.3875 104.316 89.3245 105.253 89.793L111.968 92.6039C108.376 108.064 95.4148 119.62 79.6425 121.494L79.6425 57.7798 118.683 57.7798 118.683 48.4101 79.6425 48.4101 79.6425 42.9445C86.9821 40.6021 91.5108 33.2624 90.4176 25.6105 89.1684 18.1148 82.6096 12.4929 74.9576 12.4929 67.3057 12.4929 60.7469 18.1148 59.4976 25.7667 58.4045 33.4186 62.9332 40.7582 70.2728 43.1006L70.2728 48.4101 31.2323 48.4101 31.2323 57.7798 70.2728 57.7798 70.2728 121.494C54.5005 119.464 41.539 107.908 37.9473 92.4477L44.6623 89.6368C45.5992 89.1684 46.38 88.2314 46.5362 87.1382 46.6924 86.0451 46.2239 84.952 45.2869 84.3273L27.6406 70.7413C26.7037 70.1166 25.6105 69.9605 24.5174 70.2728 23.4243 70.7413 22.7996 71.6782 22.6435 72.7714L19.8325 94.9463C19.6764 96.0395 20.1449 97.1326 21.0818 97.7572 22.0188 98.3819 23.1119 98.5381 24.2051 98.2257L29.2022 96.1956C33.4186 111.812 45.4431 124.305 60.9031 129.146L73.396 135.861C74.333 136.329 75.4261 136.329 76.3631 135.861L89.0122 128.99C104.472 124.149 116.34 111.656 120.557 96.0395L125.554 98.2257C126.647 98.6942 127.74 98.5381 128.677 97.7572 129.614 97.1326 130.083 96.0395 129.927 94.9463L127.272 72.7714Z",
    transform: "matrix(1.09808 0 0 1 6.76029 89.9031)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoatLandingLightL);
export default __webpack_public_path__ + "static/media/BoatLandingLightL.d2eac5a099f2a55c37d6f25d83094b72.svg";
export { ForwardRef as ReactComponent };